module.exports = __webpack_public_path__ + "static/media/header_title.d66be284.png";